<script>
import { ContentLoader } from "vue-content-loader";

export default {
  components: {
    ContentLoader
  }
};
</script>
<template>
  <content-loader
    style="max-width: 100%;"
    :height="180"
    :width="570"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="0" y="0" rx="0" ry="0" width="190" height="130" />
    <rect x="0" y="150" rx="0" ry="0" width="160" height="10" />
    <rect x="0" y="170" rx="0" ry="0" width="190" height="10" />
    <rect x="240" y="0" rx="0" ry="0" width="190" height="10" />
    <rect x="240" y="20" rx="0" ry="0" width="330" height="10" />
    <rect x="240" y="40" rx="0" ry="0" width="330" height="10" />
    <rect x="240" y="80" rx="0" ry="0" width="190" height="10" />
    <rect x="240" y="100" rx="0" ry="0" width="330" height="10" />
    <rect x="550" y="130" rx="0" ry="0" width="20" height="20" />
    <rect x="520" y="130" rx="0" ry="0" width="20" height="20" />
  </content-loader>
</template>
